import React, { useState } from "react";
import { PopupModal, InlineWidget } from "react-calendly";
import { Button } from "./ui/button";
import { Calendar } from "lucide-react";
import { CALENDLY_URL } from "../lib/constants";

const CALENDLY_PAGE_SETTINGS = {
  backgroundColor: "ffffff",
  primaryColor: "0a2540",
  textColor: "1e293b",
  hideEventTypeDetails: false,
  hideLandingPageDetails: false,
};

const inlineStyles = (height) => ({ height: `${height}px` });

/**
 * CalendlyButton - opens a Calendly popup. Falls back to opening URL in new tab
 * if Calendly is unreachable.
 */
export function CalendlyButton({ className = "", children, dataTestId = "calendly-popup-trigger" }) {
  const [open, setOpen] = useState(false);
  const root = typeof document !== "undefined" ? document.body : null;
  return (
    <>
      <Button
        data-testid={dataTestId}
        onClick={() => setOpen(true)}
        className={className || "bg-[#d4af37] hover:bg-[#b8951f] text-[#0a2540] font-semibold rounded-full px-7 h-12"}
      >
        <Calendar className="w-4 h-4 mr-2" /> {children || "Schedule My Consultation"}
      </Button>
      {root && (
        <PopupModal
          url={CALENDLY_URL}
          rootElement={root}
          open={open}
          onModalClose={() => setOpen(false)}
        />
      )}
    </>
  );
}

/**
 * CalendlyInline - inline widget embed for confirmation screens.
 */
export function CalendlyInline({ height = 700 }) {
  return (
    <div data-testid="calendly-inline-widget" className="rounded-2xl overflow-hidden border border-[#cbd5e1] bg-white">
      <InlineWidget
        url={CALENDLY_URL}
        styles={inlineStyles(height)}
        pageSettings={CALENDLY_PAGE_SETTINGS}
      />
    </div>
  );
}
